<section class="mb-3">
    <h3 class="text-secondary fs-5 fw-normal ps-2">{{'add_comment_mood'|translate}}</h3>

    <div class="moods moods-value-area position-relative">
        <ul class="mood-pills pt-3 mb-0">
            <li [ngClass]="{'active': mood.mood == 'excellent'}">
                <button type="button" class="bg-transparent border-0" (click)="updateMood('excellent')">
                    <i class="icon-smileys-excellent"></i>
                    @if (mood.mood == 'excellent'){
                        <p>{{ 'excellent' | translate}}</p>
                    }
                </button>
            </li>
            <li [ngClass]="{'active': mood.mood == 'good'}">
                <button type="button" class="bg-transparent border-0" (click)="updateMood('good')">
                    <i class="icon-smileys-good"></i>
                    @if (mood.mood == 'good'){
                        <p>{{ 'good' | translate}}</p>
                    }
                </button>
            </li>
            <li [ngClass]="{'active': mood.mood == 'average'}">
                <button type="button" class="bg-transparent border-0" (click)="updateMood('average')">
                    <i class="icon-smileys-average"></i>
                    @if (mood.mood == 'average'){
                        <p>{{ 'average' | translate}}</p>
                    }
                </button>
            </li>
            <li [ngClass]="{'active': mood.mood == 'hard'}">
                <button type="button" class="bg-transparent border-0" (click)="updateMood('hard')">
                    <i class="icon-smileys-hard"></i>
                    @if (mood.mood == 'hard'){
                        <p>{{ 'hard' | translate}}</p>
                    }
                </button>
            </li>
            <li [ngClass]="{'active': mood.mood == 'bad'}">
                <button type="button" class="bg-transparent border-0" (click)="updateMood('bad')">
                    <i class="icon-smileys-bad"></i>
                    @if (mood.mood == 'bad'){
                        <p>{{ 'bad' | translate}}</p>
                    }
                </button>
            </li>
        </ul>

        @if(moodSaved){
            <i class="fa fa-check animate__animated animate__flipInX pe-4" aria-label="mood saved"></i>
        }
    </div>
</section>

<section class="mt-5">
    <h3 class="text-secondary fs-5 fw-normal ps-2">{{'add_comment_comment'| translate}}</h3>
    <div class=" mb-4 moods moods-comment-area">
        <div class="comment-area position-relative ">
            @if(mood.comment){
                <button class="delete-comment-button" type="button" aria-label="delete comment" (click)="deleteComment()">
                    <i class="fa fa-times"></i>
                </button>
            }

            <div class="moodpickers-wrapper">
                <textarea class="form-control fs-5" id="{{ mood.id }}" name="comment" rows="8"
                          data-cy="comment-input"
                          [formControl]='moodCommentCtrl'
                          [attr.placeholder]=" placeholder | translate "></textarea>

                <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>
            </div>
            @if(gifPreviews?.length > 0 || linkPreviews?.length > 0){
                <div class="previews-area">
                    <div>
                        @for(gifPreview of gifPreviews; track gifPreview){
                            <tm-gif-preview [gifPreview]="gifPreview"></tm-gif-preview>
                        }
                    </div>
                    <div>
                        @for(linkPreview of linkPreviews; track linkPreview){
                            <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                        }
                    </div>
                </div>
            }

            <div class="save-area d-flex justify-content-end">
                <button type="button" class="btn btn-primary py-2 px-3 me-2" data-cy="submit-comment" 
                        [disabled]="!!mood.commentSaved && !!mood"
                        (click)="updateComment()">{{ 'add_comment_publish_comment' | translate}}
                </button>
            </div>
        </div>
    </div>
</section>
<!--

<div class="saved-comment-message">
    <p ng-show="mood.comment && mood.commentSaved"
       class="saved-comment">
        {{ 'add_comment_comment_published' | translate }}<i class="fa fa-check animate__animated animate__flipInX ps-2" aria-label="comment saved"></i>
    </p>
</div>-->